import { Route, Switch, Redirect } from 'react-router-dom';
import { DefaultLayout } from './modules/layout/components/DefautLayout';
import { PageNotFound } from './modules/router/components/PageNotFound';
import { Themes } from './modules/themes/types';
import { IndexRoutes, IndexRoutesConfig } from './modules/index/Routes';
import {
  InscribeRoutes,
  InscribeRoutesConfig,
} from './modules/inscribeMInt/Routes';
import {
  UserCenterRoutes,
  UserCenterRoutesConfig,
} from './modules/userCenter/Routes';
import { PageComingSoon } from './modules/router/components/PageComingSoon';
import {
  DynamicBitcoinRoutes,
  DynamicBitcoinRoutesConfig,
} from './modules/dynamicBitcoin/Routes';
import { DocsRoutes, DocsRoutesConfig } from './modules/docs/Routes';

const LEGACY_REDIRECT_PATHS = [
  '/passover',
  '/invt',
  '/migrate',
  '/insc',
  '/compensation',
];

export function Routes() {
  return (
    <Switch>
      <Route
        exact
        path="/"
        render={() => <Redirect to={IndexRoutesConfig.Index.path} />}
      />
      <Route
        exact
        path={IndexRoutesConfig.Index.path}
        render={() => (
          <DefaultLayout headerTheme={Themes.light}>
            <IndexRoutes />
          </DefaultLayout>
        )}
      />
      <Route
        exact
        path={LEGACY_REDIRECT_PATHS}
        render={() => <Redirect to={DynamicBitcoinRoutesConfig.Index.path} />}
      />
      <Route
        exact
        path={InscribeRoutesConfig.Index.path}
        render={() => (
          <DefaultLayout headerTheme={Themes.light}>
            <InscribeRoutes />
          </DefaultLayout>
        )}
      />
      <Route
        exact
        path={UserCenterRoutesConfig.Index.path}
        render={() => (
          <DefaultLayout headerTheme={Themes.light}>
            <UserCenterRoutes />
          </DefaultLayout>
        )}
      />
      <Route
        path={[
          DynamicBitcoinRoutesConfig.Minesweeper.path,
          DynamicBitcoinRoutesConfig.GeneDetail.path,
          DynamicBitcoinRoutesConfig.Index.path,
        ]}
        render={() => (
          <DefaultLayout headerTheme={Themes.light}>
            <DynamicBitcoinRoutes />
          </DefaultLayout>
        )}
      />

      <Route
        exact
        path={DocsRoutesConfig.Index.path}
        render={() => (
          <DefaultLayout headerTheme={Themes.light}>
            <DocsRoutes />
          </DefaultLayout>
        )}
      />
      <Route
        exact
        path={'/actress/coming_soon'}
        render={() => (
          <DefaultLayout headerTheme={Themes.light}>
            <PageComingSoon />
          </DefaultLayout>
        )}
      />
      <Route
        render={() => (
          <DefaultLayout>
            <PageNotFound />
          </DefaultLayout>
        )}
      />
    </Switch>
  );
}
